/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from "react";
import NoJobsFound from "assets/svgs/NoJobsFound";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import { useWindowResize } from "utils/hooks";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";
import { useRouter } from "next/router";
import { Container, Description, Heading } from "./styles";

type NoJobViewProps = {
	filterCount: number;
};

const NoJobsView: React.FC<NoJobViewProps> = ({ filterCount }) => {
	const router = useRouter();
	const {
		appliedFiltersCount,
		titleSearchObject,
		citySearchObject,
		clearAllFilters,
		discoveryTabs,
	} = useJobFeedStore();
	const [isMobileView] = useWindowResize();
	const isInternationalPage = router.pathname === "/international/jobs";
	useEffect(() => {
		if (isMobileView) {
			trackOnMixpanel("ZSR_Screen_Viewed Web", {
				is_filter_applied_search: isMobileView && !!filterCount,
				"Search Feature Used":
					(typeof titleSearchObject === "string" && "Fuzzy") ||
					(titleSearchObject?.display_name && "Suggested"),
				"User Entered Query":
					titleSearchObject?.display_name ||
					(typeof titleSearchObject === "string" ? titleSearchObject : null),
				"Entity Type":
					titleSearchObject?.type || titleSearchObject?.entity_type || null,
				// "Location Search Feature Used": citySearchObject?.name,
				"User Entered Location Query": citySearchObject?.name,
				"Location Type": citySearchObject?.type,
			});
		} else {
			trackOnMixpanel("ZSR_Screen_Viewed Web", {
				is_filter_applied_search: !isMobileView && !!appliedFiltersCount,
				"Search Feature Used":
					(typeof titleSearchObject === "string" && "Fuzzy") ||
					(titleSearchObject?.display_name && "Suggested"),
				"User Entered Query":
					titleSearchObject?.display_name ||
					(typeof titleSearchObject === "string" ? titleSearchObject : null),
				"Entity Type":
					titleSearchObject?.type || titleSearchObject?.entity_type || null,
				// "Location Search Feature Used": citySearchObject?.name,
				"User Entered Location Query": citySearchObject?.name,
				"Location Type": citySearchObject?.type,
			});
		}
	}, []);

	const getNoJobsMessage = () => {
		if (appliedFiltersCount > 0) {
			return "Clear filters to see jobs or explore jobs in other cities";
		}
		if (discoveryTabs.showTabs && discoveryTabs.activeTabId) {
			return "Explore jobs in other Tabs";
		}
		return "Please try searching for another keyword or location";
	};

	const getActiveDiscoveryTabZSRMessage = () => {
		if (!discoveryTabs.showTabs || !discoveryTabs.activeTabId) return "";

		const tabMessages = {
			2: "in high salary",
			3: "in nearby",
			4: "in new jobs",
		};

		return tabMessages[discoveryTabs.activeTabId] || "";
	};

	return (
		<Container className="border-1 border-black py-[36px]">
			<NoJobsFound />
			<Heading className="mt-3 md:mt-6">
				Sorry, no jobs found {getActiveDiscoveryTabZSRMessage()}
			</Heading>
			<Description className="mt-1">{getNoJobsMessage()}</Description>
			{appliedFiltersCount > 0 && !isInternationalPage && (
				<div
					className="mt-[24px] flex w-max cursor-pointer items-center gap-[4px] rounded-3xl border border-solid border-[#C00] bg-[#FBECED] px-[12px] py-[8px]"
					onClick={() => {
						clearAllFilters();
					}}
				>
					<p className="m-0 text-sm font-semibold leading-[20px] text-[#C00]">
						Clear filters
					</p>
					<CrossIcon fill="#C00" />
				</div>
			)}
			{/* 
			{isUserLoggedIn() && recentSearches?.length > 0 && (
				<>
					<SubHeading className="mt-4 md:mt-8">Recent searches</SubHeading>
					<TrendingJobs className="mt-3 flex max-w-[900px] flex-row flex-wrap justify-center gap-2 px-4 md:mt-6">
						{recentSearches.map((job: any) => (
							<Chip
								color="primary"
								key={job.id}
								onClick={() => {
									const searchEventObj = getSearchEventProps();
									const obj = {
										[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
											"Recent_ZSR",
									};
									const resObj = { ...searchEventObj, ...obj };
									setSearchEventProps(resObj);
									handleSelect(job);
									resetSearch();
									resetFilters();
								}}
								label={job.name}
								variant="outlined"
							/>
						))}
					</TrendingJobs>
				</>
			)} */}
			{/* {popularSearches?.length > 0 && (
				<>
					<SubHeading className="mt-4 md:mt-8">Popular searches</SubHeading>

					<TrendingJobs className="mt-3 flex max-w-[900px] flex-row flex-wrap justify-center gap-2 px-4 md:mt-6">
						{popularSearches.map((job: any) => (
							<Chip
								color="primary"
								key={job.id}
								onClick={() => {
									const searchEventObj = getSearchEventProps();
									const obj = {
										[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
											"Popular_ZSR",
									};
									const resObj = { ...searchEventObj, ...obj };
									setSearchEventProps(resObj);
									handleSelect(job);
									resetSearch();
									resetFilters();
								}}
								label={job.name}
								variant="outlined"
							/>
						))}
					</TrendingJobs>
				</>
			)} */}
			{/* {!isUserLoggedIn() && departmentData?.length > 0 && (
				<>
					<SubHeading className="mt-4 md:mt-8">Trending departments</SubHeading>
					<TrendingJobs className="mt-3 flex w-full max-w-[900px] flex-row gap-8 overflow-scroll px-4 md:mt-6 md:justify-center">
						{(departmentData as any)?.slice(0, 5).map((department: any) => (
							<div
								key={department.id}
								className="flex w-[100px] min-w-[100px] cursor-pointer flex-col items-center gap-4 overflow-auto hover:bg-[#f2efef]"
								onClick={() => {
									handleSelect({ name: department.name });
								}}
							>
								<img
									src={
										department.icon ||
										"https://cdn.apna.co/employerDashboard_FE/department-icons/Finance%20%26%20Accounting.svg"
									}
									alt={department.name}
								/>
								<div className="line-clamp-2 w-full text-center text-[16px]">
									{department.name}
								</div>
							</div>
						))}
					</TrendingJobs>
				</>
			)} */}
		</Container>
	);
};

export default NoJobsView;
